import { render, staticRenderFns } from "./viewMyDocument.vue?vue&type=template&id=1ba34c04&scoped=true"
import script from "./viewMyDocument.vue?vue&type=script&lang=js"
export * from "./viewMyDocument.vue?vue&type=script&lang=js"
import style0 from "./viewMyDocument.vue?vue&type=style&index=0&id=1ba34c04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba34c04",
  null
  
)

export default component.exports